"use strict";

exports.__esModule = true;
exports.ButtonContentStyle = exports.ButtonStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theme = _interopRequireDefault(require("./theme"));

var _containers = require("./containers");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n  /*SKEWED design*/\n  ", "\n  font-size:  ", ";\n  font-weight: ", ";\n \n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  cursor: pointer;\n  display: flex;\n  ", "\n  ", "\n  justify-content: ", ";\n  width: ", ";\n  height: ", ";\n  border-radius: ", ";\n  ", "\n  ", "\n  ", "\n  ", "\n  font-size:  ", ";\n  font-weight: ", ";\n  padding: ", ";\n  border-style: solid;\n  overflow: hidden;\n  ", "\n\n  /*SKEWED design*/\n  ", "\n\n  \n  &:active {\n    ", "\n    ", "\n    ", "\n  }\n  &:focus {\n    outline: none;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var ButtonStyled = _styledComponents["default"].button(_templateObject(), function (props) {
  return props.flex ? "flex: " + props.flex + ";" : "";
}, function (props) {
  return props.alignItems ? "align-items: " + props.alignItems + ";" : "";
}, function (props) {
  return props.justifyContent ? props.justifyContent : "center";
}, function (props) {
  return props.width || "8rem";
}, function (props) {
  return props.height || "min-content";
}, function (props) {
  return props.borderRadius ? props.borderRadius : props.rounded ? ".2rem" : ".2rem";
}, function (props) {
  return props.margin ? "margin: " + props.margin + ";" : "";
}, function (props) {
  return props.color ? "background-color: " + (props.disabled ? props.disabledColor : props.color) + ";" : props.primary ? "background-color: " + (props.disabled ? _theme["default"]["default"].primary50P : _theme["default"]["default"].primary) + "; border-color: " + (props.disabled ? _theme["default"]["default"].primary50P : _theme["default"]["default"].primary) + ";" : props.secondary ? "background-color: " + (props.disabled ? _theme["default"]["default"].secondarySky10P : _theme["default"]["default"].secondarySky25P) + "; border-color: " + (props.disabled ? _theme["default"]["default"].secondarySky10P : _theme["default"]["default"].secondarySky25P) + ";" : "";
}, function (props) {
  return (props.borderColor || props.color) && "border-color: " + (props.borderColor || props.color) + ";";
}, function (props) {
  return props.textColor ? "color: " + props.textColor + ";" : props.primary ? "color: " + _theme["default"]["default"].primaryTextColor + ";" : props.secondary ? "color: " + (props.disabled ? _theme["default"]["default"].primary50P : _theme["default"]["default"].primary) + ";" : "";
}, function (props) {
  return props.fontSize || "1.2rem";
}, function (props) {
  return props.fontWeight || "400";
}, function (props) {
  return props.padding ? props.padding : "1.2rem 0";
}, function (props) {
  return props.clickAnimation === "highlight" && !props.disabled && "\n    transition: opacity 0.1s ease-in-out;\n    -webkit-transition: opacity 0.1s ease-in-out;\n    -moz-transition: opacity 0.1s ease-in-out;\n    -o-transition: opacity0.1s ease-in-out;\n    ";
}, function (props) {
  return props.rounded ? "\n      -ms-transform: skewX(-20deg);\n      -webkit-transform: skewX(-20deg);\n      transform: skewX(-20deg);\n    " : "";
}, function (props) {
  return props.clickAnimation !== "highlight" && !props.disabled && "\n      -ms-transform: translateY(4px);\n      -webkit-transform: translateY(4px);\n      transform: translateY(4px);";
}, function (props) {
  return props.clickAnimation !== "highlight" && !props.disabled && props.rounded && "\n        -ms-transform: skewX(-20deg) translateY(4px);\n        -webkit-transform: skewX(-20deg) translateY(4px);\n        transform: skewX(-20deg) translateY(4px);\n      ";
}, function (props) {
  return props.clickAnimation === "highlight" && !props.disabled && "\n      opacity: 0.5;\n      ";
});

exports.ButtonStyled = ButtonStyled;
var ButtonContentStyle = (0, _styledComponents["default"])(_containers.FlexRow)(_templateObject2(), function (props) {
  return props.rounded ? "\n      -ms-transform: skewX(20deg);\n      -webkit-transform: skewX(20deg);\n      transform: skewX(20deg);  \n      display: inline-block;\n    " : "";
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight;
});
exports.ButtonContentStyle = ButtonContentStyle;